import React, { useEffect, useLayoutEffect, useState, useCallback } from "react";
import cn from "classnames";
import { flowType } from "@utility/userInfo";
import { COUNTRY_CODE } from "@constants";
import LoyaltyKeyboard from "@components/LoyaltyInOrder/orderLoyaltyKeyboard";
import { getObjectValue } from "@utility/utills";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { LABEL, CUSTOM_MESSAGES } from "../../veriables";
import { setPaymentCheck, setSeat } from '@reducers/orders';
import { updateLoyaltyCheck } from '@reducers/storeChecks';
import { handleLoyaltyInfo, loyaltyNewBalance, setOrderLoyaltyType, orderLoyaltySignIn, orderLoyaltySignUp, orderApplyLoyaltyOffer, orderDeleteLoyaltyAccount, orderLoyaltyGetOffers, paymentLoyaltyGetOffers, clearLoyaltyEntrySource } from "@reducers/loyalty";
import { showSuccessCheckMark, setErrorPopUp } from "@reducers/notification";
import FullWidthModal from "../common/Modal/FullWidthModal";
import EventEmitter from "@utility/eventSubscribers";
import OrderLoyaltyJoinScreen from './loyaltyJoinScreen';
import OrderLoyaltySignUpConfirmation from "./orderLoyaltySignUpConfirmation";
import OrderLoyaltyOffers from "./orderLoyaltyOffers";
import Loader from '@components/common/Loader/newLoaderModal';
import ModalHeader from '../common/ModalHeader/index';
import PropTypes from 'prop-types';
import LoyaltyLandingPage from '@components/LoyaltyInOrder/LoyaltyLandingPage';
import OfferListModal from './ViewloyaltyOffers';

const LoyaltyBalance = (props) => {

  const { handleLoyaltyInfo, loyaltyType, isOpen, check, currentSeat, paymentLandscapeOrientation } = props;
  const isServer = flowType() === "serverApp";
  const [currentSeatId, setCurrentSeatId] = useState();
  const loyaltyInfo = props?.auth?.loyaltyInfo;
  let storeImage = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem("auth"), ""),
  );
  const ShowLandscapeMode =
    isServer &&
    props.deviceInfo?.deviceGroup?.startMode === 0 &&
    paymentLandscapeOrientation;

  const [joinMethod, setJoinMethod] = useState();
  const [countryCode, setCountryCode] = useState(() => {
    return getObjectValue(
      () => COUNTRY_CODE[props.auth?.country].dialCode,
      "1",
    );
  });
  const loyaltyOffers = {}
  const [loyaltyMethod, setLoyaltyMethod] = useState();
  const [joinClicked, setJoinClicked] = useState(false);
  const [alreadyMem, setAlreadyMem] = useState(true);
  const [newOfferPopUp, setNewOfferPopUp] = useState(false);
  const auth = props.auth?.loyaltyInfo?.lookupMethods;
  const lookupMethods = auth?.length === 1;
  const { position, seat: seatsData } = props;
  const [isLandScape, setIsLandScape] = useState(
        window.innerWidth > window.innerHeight
      );


  useLayoutEffect(() => {
    if (window.ReactNativeWebView) {
      EventEmitter.changeOrientation({
        orientation: "landscape",
      });
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
         setIsLandScape(window.innerWidth > window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
  }, [])

  const viewOffersOnclick = () => {
    const data = {
      storeId: props?.deviceInfo?.storeId,
      deviceId: props?.deviceInfo?.deviceId,
      employeeId: props?.userInfo?.id,
      countryCode,
      employeeCard: props?.userInfo?.employeeCard,
      checkHeaderId: props?.seat?.id,
      seatId: null,
      loyalty: {
        accountNumber: null
      },
      paymentCheck: seatsData?.paymentCheck,
      paymentChecks: seatsData?.paymentChecks
    }
    props?.orderLoyaltyGetOffers(data).then(() => {
      props.setOrderLoyaltyType(6);
      setNewOfferPopUp(true);
    }).catch((err) => {
      props.setErrorPopUp({
        res: err.message
      })
    })

  }


  const handleRouteToChecKListing = () => {
    if (window.ReactNativeWebView) {
      EventEmitter.changeOrientation({
        orientation: "landscape",
      });
    }
    props.clearLoyaltyEntrySource();
    props.onClose();
  };

  const handleLoyaltySignIn = (type) => {
    setLoyaltyMethod(type);
    props.setOrderLoyaltyType(2);
  };

  const openLoyaltyKeyboard = (type) => {
    setJoinMethod(type);
    props.setOrderLoyaltyType(4);
  };

  const handleLoyaltyClick = (type, seatId) => (event) => {
    setCurrentSeatId(seatId);
    event.preventDefault();
    handleLoyaltySignIn(type);
    setJoinClicked(type === 'signUp');
    setAlreadyMem(type !== 'signUp');
  };

  const getName = () => {
    const methodName = joinMethod;
    let name = methodName;
    if (methodName === "phone") {
      name = "PhoneNumber";
    } else if (methodName === "type") {
      name = "AccountNumber";
    } else if (methodName === "email") {
      name = "Email";
    }
    return name;
  };

  const getPlaceHolder = () => {
    const methodName = joinMethod;
    let name = methodName;
    if (methodName === "phone") {
      name = LABEL().OLS_PHONE;
    } else if (methodName === "type") {
      name = LABEL().LS_ACCOUNT;
    } else if (methodName === "email") {
      name = LABEL().OLS_EMAIL;
    }
    return name;
  };

  const isImage = () =>
    !!(loyaltyInfo?.signUpImageUrl || loyaltyInfo?.imageUrl || storeImage?.imageUrl);

  const handleLoyaltySubmit = (inputData, fieldName) => {
    let dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      countryCode,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: props.seat.id,
      seatId: currentSeatId,
      // paymentCheck: props.seat?.paymentCheck || paymentCheck,
      // paymentChecks: props.seat?.paymentChecks,
    };
    switch (fieldName) {
      case 'PhoneNumber': dataToSend = {
        ...dataToSend, loyalty: { phoneNumber: inputData, accountNumber: '', emailAddress: '', method: 'phone', countryCode }
      }; break;

      case 'AccountNumber': dataToSend = {
        ...dataToSend, accountNumber: inputData, phoneNumber: '', emailAddress: '', method: 'type'
      }; break;

      default: dataToSend = {
        ...dataToSend, accountNumber: '', phoneNumber: '', emailAddress: inputData, method: 'email'
      }; break;
    }
    if (loyaltyMethod === 'signIn') {
      props.orderLoyaltySignIn(JSON.stringify(dataToSend)).then((res) => {
        window.sessionStorage.setItem('loyaltyData', JSON.stringify(res?.loyalty));
        props.updateLoyaltyCheck({
          ...props.check,
          ...res.check,
        });
        props.setPaymentCheck({
          ...res?.paymentCheck,
          loyalty: res?.loyalty,
          paymentCheck: res?.paymentCheck,
          loyalties: res?.check?.loyalties,
        })
        props.setSeat({
          ...props.seat,
          loyalty: res?.loyalty,
          seats: res?.check?.seats,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
          loyalties: res?.check?.loyalties,
        })
        props.setOrderLoyaltyType(5);
      }).catch((err) => {
        props.handleLoyaltyInfo({ phoneNumber: null, email: null, type: null })
        props.setErrorPopUp({
          res: err.message
        })
      });
    } else if (loyaltyMethod === 'signUp') {
      props.orderLoyaltySignUp(JSON.stringify(dataToSend)).then((res) => {
        props.updateLoyaltyCheck({
          ...props.check,
          ...res.check,
        });
        props.setPaymentCheck({
          ...res?.paymentCheck,
          loyalty: res?.loyalty,
          paymentCheck: res?.paymentCheck,
        })
        props.setSeat({
          ...props.seat,
          loyalty: res?.loyalty,
          seats: res?.check?.seats,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
          loyalties: res?.check?.loyalties,
        })
        props.setOrderLoyaltyType(3);
      }).catch((err) => {
        props.setErrorPopUp({
          res: err.message
        })
      });
    }
  };

  const handleApplyOffer = (offer) => {
    let dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: props.seat.id,
      seatId: (Number(position?.number) === -1) ? null : position?.id,
      countryCode,
      offer: {
        vendorId: offer[0]?.vendorId,
        offerCode: offer[0]?.offerCode,
        offerAuthCode: null,
        name: offer[0]?.name,
        value: offer[0]?.value,
        quantity: offer[0]?.quantity,
        isCoupon: offer[0]?.isCoupon ? offer[0]?.isCoupon : false,
      },
      // paymentCheck: props.seat.paymentCheck,
      // paymentChecks: props.seat.paymentChecks,
    }
    props.orderApplyLoyaltyOffer(dataToSend).then((res) => {
      props.setSeat({
        ...props.seat,
        ...res.check,
      })
      props.updateLoyaltyCheck({
        ...props.seat,
        ...res.check,
      })
      props.setPaymentCheck({ ...props.paymentCheck, paymentCheck: res.paymentCheck });
      props.onClose();
    }).catch((err) => {
      props.setErrorPopUp({
        res: err.message
      })
    })
  };

  const deleteLoyalty = useCallback((seatId) => () => {
    const dataToSend = {
      deviceId: props?.deviceInfo?.deviceId,
      employeeId: props?.userInfo?.id,
      storeId: props?.deviceInfo?.storeId,
      checkHeaderId: props?.seat?.id,
      seatId: seatId ?? currentSeatId,
      countryCode,
      employeeCard: props?.userInfo?.employeeCard,
    };
    props
      .orderDeleteLoyaltyAccount(dataToSend)
      .then((res) => {
        props.setSeat({
          ...props.seat,
          ...res.check,
        });
        props.updateLoyaltyCheck({
          ...props.seat,
          ...res.check,
        });
        props.setPaymentCheck({
          ...res?.paymentCheck,
          loyalty: res?.loyalty,
          paymentCheck: res?.paymentCheck,
        });
        props.setOrderLoyaltyType(1);
      })
      .catch((err) => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  }, [
    props?.deviceInfo,
    props?.userInfo,
    props.seat
  ]);

  const handleOrderBackButton = () => {
    if ([4].includes(loyaltyType)) {
      props.setOrderLoyaltyType(lookupMethods ? 1 : 2);
    } else if ([2].includes(loyaltyType)) {
      props.setOrderLoyaltyType(1);
    }
  };

  const backToLandingPage = () => {
    props.setOrderLoyaltyType(1)
  }

  const noOfferSelectedPopUp = () => {
    props.setErrorPopUp({
      res: CUSTOM_MESSAGES().OLS_LOYALTY_SELECT_OFFER,
      noErrorTxt: true,
    });
  }

  const themeProperties = JSON.parse(window.sessionStorage.getItem("themeProperties"));
  const seats = props.seat?.seats || [];

  const handleLoyaltyFlow = (type) => {
    switch (type) {
      case 1:
        return (
          <LoyaltyLandingPage 
            seats={seats}
            serverAppTheme={props.serverAppTheme}
            handleLoyaltySignIn={handleLoyaltySignIn}
            deleteLoyalty={deleteLoyalty}
            onClose={props?.onClose}
            handleLoyaltyClick={handleLoyaltyClick}
            setOrderLoyaltyType={props.setOrderLoyaltyType}
            viewOffersOnclick={viewOffersOnclick}
          />
        )
      case 2:
        return (
          <OrderLoyaltyJoinScreen
            onBack={handleRouteToChecKListing}
            serverAppTheme={props.serverAppTheme}
            themeProperties={themeProperties}
            loyaltyMethod={loyaltyMethod}
            loyaltyInfo={loyaltyInfo}
            openLoyaltyKeyboard={openLoyaltyKeyboard}
            storeImage={storeImage}
            joinClicked={joinClicked}
            // alreadyMem={alreadyMem}
            handleOrderBackButton={handleOrderBackButton}
            isLandScape={isLandScape}

          />
        )
      case 3:
        return (
          <OrderLoyaltySignUpConfirmation
            loyaltyInfo={loyaltyInfo}
            serverAppTheme={props?.serverAppTheme}
            setOrderLoyaltyType={props.setOrderLoyaltyType}
            isLandScape={isLandScape}
          />
        );
      case 4:
        return (
          <LoyaltyKeyboard
            countryCode={countryCode}
            joinMethod={joinMethod} //not needed
            handleLoyaltySubmit={handleLoyaltySubmit}
            name={getName()}
            placeHolder={getPlaceHolder()}
            handleCountryCodeChange={(e) => setCountryCode(e.id)}
            loyaltyInfo={loyaltyInfo}
            loyaltyMethod={loyaltyMethod}
            handleOrderBackButton={handleOrderBackButton}
            ShowLandscapeMode={ShowLandscapeMode}
            isImage={isImage}
            handleLoyaltyInfo={handleLoyaltyInfo}
            serverAppTheme={props?.serverAppTheme}
            themeProperties={themeProperties}
            loyaltyType={loyaltyType}
            handleCancel={handleRouteToChecKListing}
            lookupMethods={lookupMethods}
            isLandScape={isLandScape}
            setErrorPopUp={props.setErrorPopUp}
          />
        )
       case 5:
        return (
          <OrderLoyaltyOffers
            deleteLoyalty={deleteLoyalty}
            loyaltyType={loyaltyType}
            loyaltyInfo={loyaltyInfo}
            handleLoyaltyNotNow={backToLandingPage}
            groupedLoyaltyOfferData={props.groupedLoyaltyOffer}
            loyaltyRes={loyaltyOffers}
            handleApplyOffer={handleApplyOffer}
            storeImage={storeImage}
            handleOrderBackButton={handleOrderBackButton}
            serverAppTheme={props?.serverAppTheme}
            isLandScape={isLandScape}
            noOfferSelectedPopUp={noOfferSelectedPopUp}
            seat={props.seat}
            currentSeatId={currentSeatId}
          />
        )
      case 6:
        return (
           <OfferListModal
            newOfferPopUp={newOfferPopUp}
            serverAppTheme={props?.serverAppTheme}
            seat={props.loyaltyViewOffers}
            setNewOfferPopUp={setNewOfferPopUp}
            handleDoneBtnClick={backToLandingPage}
            loading={props?.loading}
          />
        )
      default:
        return <></>;
    }
  };
const getTileHeaderByLoyaltyType = (loyaltyType, loyaltyMethod) => {
  switch(loyaltyType) {
    case 1:
      return `${LABEL().OLLS_LOYALTY_SIGN_UP}`;
    case 2:
      return loyaltyMethod === 'signIn'
        ? `${LABEL().OLS_SIGN_IN_TO_LOYALTY}`
        : `${LABEL().OLS_SIGN_UP_TO_LOYALTY}`;
    case 3:
      return loyaltyMethod === 'signIn'
        ? `${LABEL().OLS_SIGN_IN}`
        : `${LABEL().OLS_SIGN_UP}`;
    case 4:
      return loyaltyMethod === 'signIn'
        ? `${LABEL().OLS_SIGN_IN}`
        : `${LABEL().OLS_SIGN_UP}`;
    case 5:
      return `${LABEL().OLS_OFFERS}`;
    default:
      return `${LABEL().OLLS_LOYALTY_SIGN_UP}`;
  }
};
  return (
  <>
    {props.loading && <Loader />}
    <FullWidthModal
      isOpen={isOpen}
      customClass2={cn("w-100 h-100 position-relative")}
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        pointerEvents: "auto",
        backgroundColor: props.serverAppTheme?.popUp_bg,
        backgroundClip: "padding-box",
        border: "0",
        boxShadow: props.serverAppTheme?.popUp_box_shadow,
      }}
    >
      <div className="d-flex flex-column w-100 h-100">
        <ModalHeader
          isTab={check?.tab}
          stationName={check?.stationName}
          tileHeader={getTileHeaderByLoyaltyType(loyaltyType, loyaltyMethod || 'signIn')}
          seatNumber={check?.number}
          customHeight={'35px'}
        />
        <div className={cn("flex-grow-1", isLandScape ? 'px-0 h-95' : 'p-3')}>
        {handleLoyaltyFlow(loyaltyType)}
        </div>
      </div>
    </FullWidthModal>
  </>
);
};


const mapStateToProps = ({ oauth, orders, loyalty, theme, payment }) => ({
  loading: loyalty.loading || orders.loading || oauth.loading || theme.loading,
  auth: oauth.authInfo,
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  seat: orders.seats,
  position: orders.position,
  serverAppTheme: theme.serverAppTheme,
  loyaltyType: loyalty.loyaltyType,
  groupedLoyaltyOffer: loyalty.groupedLoyaltyOffer,
  offers: loyalty?.orderLoyaltyOffers || {},
  paymentLandscapeOrientation: payment.paymentLandscapeOrientation,
  loyaltyViewOffers: loyalty?.loyaltyViewOffers,
  loyaltyEntrySource: loyalty.loyaltyEntrySource,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleLoyaltyInfo,
      loyaltyNewBalance,
      showSuccessCheckMark,
      setErrorPopUp,
      setOrderLoyaltyType,
      orderLoyaltySignIn,
      setPaymentCheck,
      setSeat,
      orderLoyaltySignUp,
      orderApplyLoyaltyOffer,
      orderDeleteLoyaltyAccount,
      orderLoyaltyGetOffers,
      paymentLoyaltyGetOffers,
      updateLoyaltyCheck,
      clearLoyaltyEntrySource,
    },
    dispatch,
  );

LoyaltyBalance.propTypes = {
  /* modal / ui */
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  onClose: PropTypes.func,

  /* redux state */
  auth: PropTypes.object,
  deviceInfo: PropTypes.object,
  userInfo: PropTypes.object,
  seat: PropTypes.object,
  position: PropTypes.object,
  check: PropTypes.object,
  currentSeat: PropTypes.object,

  /* loyalty */
  loyaltyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  groupedLoyaltyOffer: PropTypes.object,
  loyaltyViewOffers: PropTypes.object,

  /* theme */
  serverAppTheme: PropTypes.shape({
    popUp_bg: PropTypes.string,
    popUp_box_shadow: PropTypes.string,
  }),

  /* redux actions */
  handleLoyaltyInfo: PropTypes.func.isRequired,
  setOrderLoyaltyType: PropTypes.func,
  orderLoyaltySignIn: PropTypes.func,
  orderLoyaltySignUp: PropTypes.func,
  orderApplyLoyaltyOffer: PropTypes.func,
  orderDeleteLoyaltyAccount: PropTypes.func,
  orderLoyaltyGetOffers: PropTypes.func,
  paymentLoyaltyGetOffers: PropTypes.func,

  setPaymentCheck: PropTypes.func,
  setSeat: PropTypes.func,
  updateLoyaltyCheck: PropTypes.func,
  setErrorPopUp: PropTypes.func,
};

LoyaltyBalance.defaultProps = {
  isOpen: false,
  loading: false,
  onClose: () => { },

  auth: null,
  deviceInfo: null,
  userInfo: null,
  seat: null,
  position: null,
  check: null,
  currentSeat: null,

  loyaltyType: null,
  groupedLoyaltyOffer: {},
  loyaltyViewOffers: null,
  LoyaltyBalance: null,

  serverAppTheme: {
    popUp_bg: "",
    popUp_box_shadow: "",
  },

  setOrderLoyaltyType: () => { },
  orderLoyaltySignIn: () => { },
  orderLoyaltySignUp: () => { },
  orderApplyLoyaltyOffer: () => { },
  orderDeleteLoyaltyAccount: () => { },
  orderLoyaltyGetOffers: () => { },
  paymentLoyaltyGetOffers: () => { },

  setPaymentCheck: () => { },
  setSeat: () => { },
  updateLoyaltyCheck: () => { },
  setErrorPopUp: () => { },
};

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyBalance);
